<ng-container *transloco="let t">
  <p-sidebar
    #sidebar
    [visible]="(gridService.exportDataPanel$ | async) === 'open'"
    styleClass="export-sidebar sidebar-large"
    [dismissible]="false"
    [blockScroll]="true"
    appendTo="body"
    (onHide)="onHide($event)"
  >
    <h1 class="z-sidebar-title"><i class="fa-thin fa-file-export"></i> {{ t('core.components.grid.export.export_data') }}</h1>

    <div class="z-sidebar-controls p-fluid grid">
      <div class="col-6">
        <button
          pButton
          type="button"
          label="{{ t('core.components.grid.export.download') }}"
          icon="fad fa-download"
          class="p-button-outlined p-button-success"
          (click)="export()"
          [disabled]="exportService.loading$ | async"
        ></button>
      </div>

      <div class="col-6">
        <button
          pButton
          type="button"
          icon="fad fa-undo-alt"
          label="{{ t('core.components.grid.export.reset') }}"
          class="p-button-secondary p-button-outlined"
          (click)="reset()"
          [disabled]="exportService.loading$ | async"
        ></button>
      </div>
    </div>

    <div class="z-sidebar-content">
      <div class="p-fluid formgrid grid relative z-sidebar-grid-export" [formGroup]="form">
        <div class="col-12">
          <div class="p-fluid formgrid grid">
            <div class="field col-12 mt-5">
              <z-combo-box
                label="{{ t('core.components.grid.export.file_format') }}"
                placeholder="{{ t('core.components.grid.export.select_format') }}"
                fieldName="format"
                [list]="fileFormatList"
                [selectedItemShowDescription]="false"
                selectedItemLabelColumn="column2"
                [columnsConfig]="{
                  column1: { dropdown: { display: false } }
                }"
              ></z-combo-box>
            </div>

            <div
              class="field col-12 include-highlights"
              [class.include-highlights-show]="(form.get('format').valueChanges | async) === 'xlsx'"
            >
              <p-checkbox
                inputId="filter-includeHighlights"
                formControlName="includeHighlights"
                [binary]="true"
                trueValue="Y"
                falseValue="N"
                label="{{ t('core.components.grid.export.include_highlights') }}"
                pTooltip="{{ t('core.components.grid.export.include_highlights_tooltip') }}"
                tooltipPosition="bottom"
                appendTo="body"
                [showDelay]="500"
                [hideDelay]="250"
              ></p-checkbox>
            </div>

            <div class="field col-12 mt-4">
              <label for="row-count">{{ t('core.components.grid.export.number_of_rows') }}</label>
              <input type="text" pInputText [value]="form.get('rows').valueChanges | async" readonly />

              <p-slider
                formControlName="rows"
                [step]="step"
                [min]="minRows"
                [max]="maxRows"
                [animate]="true"
                styleClass="mt-3"
                [style]="{ width: '95%', marginLeft: 'auto', marginRight: 'auto' }"
              ></p-slider>
            </div>

            <div
              class="field col-12 excessive-rows-warning"
              [class.excessive-rows-warning-show]="(form.get('rows').valueChanges | async) >= warningRowCount"
            >
              <p-message severity="warn" [escape]="false" text="{{ t('core.components.grid.export.excessive_rows_warning') }}"></p-message>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="loading-spinner" [class.loading-spinner-display]="exportService.loading$ | async">
            <svg viewBox="0 0 100 25">
              <g class="blue-dot-2">
                <circle class="zethcon-blue blue-dot-1" cx="30%" cy="50%" r="5" />
              </g>

              <g class="grey-dot-2">
                <circle class="zethcon-grey grey-dot-1" cx="50%" cy="50%" r="5" />
              </g>

              <g class="orange-dot-2">
                <circle class="zethcon-orange orange-dot-1" cx="70%" cy="50%" r="5" />
              </g>
            </svg>

            <div class="loading-message" [class.loading-message-display]="exportService.loading$ | async">
              {{ exportService.step$ | async }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-sidebar>
</ng-container>
